import {createStore, compose, applyMiddleware, combineReducers} from 'redux';
import {thunk} from 'redux-thunk';
import { blindboxListReducer, botForumStatReducer, botReducer, certificateListReducer, filenamesIuiuReducer, filenamesReducer, MCQListReducer, userForumStatReducer, userReducer } from './reducers/allData';

const initialState = {
    // userSignin: {
    //     userInfo: localStorage.getItem('userInfo')
    //     ? JSON.parse(localStorage.getItem('userInfo'))
    //     : null,
    // },
    // postDetails: {
    //     post: localStorage.getItem('userLSP')
    //     ? JSON.parse(localStorage.getItem('userLSP'))
    //     : "nothing",
    // }
    
    // cart:{
    //     cartItems: localStorage.getItem('cartItems')? JSON.parse(localStorage.getItem('cartItems')) : [],    
    //     paymentMethod: 'Cash',
    //     shippingAddress: localStorage.getItem('shippingAddress'),
    // }
    userData: {loading: false, error: false, user: JSON.parse(localStorage.getItem('users'))},
    userForumStatData: {loading: false, error: false, userForumStat: JSON.parse(localStorage.getItem('userForumStat'))},
    botData: {loading: false, error: false, bot: JSON.parse(localStorage.getItem('bot'))},
    botForumStatData: {loading: false, error: false, botForumStat: JSON.parse(localStorage.getItem('botForumStat'))},
    filenamesData: {loading: false, error: false, filenames: JSON.parse(localStorage.getItem('filenames'))},
    filenamesIuiuData: {loading: false, error: false, filenames: JSON.parse(localStorage.getItem('filenamesIuiu'))},
    certificateListData: {loading: false, error: false, filenames: JSON.parse(localStorage.getItem('certificateList'))},
    blindboxListData: {loading: false, error: false, filenames: JSON.parse(localStorage.getItem('blindboxList'))},

};

const reducer = combineReducers({
    userData: userReducer,
    userForumStatData: userForumStatReducer,
    botData: botReducer,
    botForumStatData: botForumStatReducer,
    filenamesData: filenamesReducer,
    filenamesIuiuData: filenamesIuiuReducer,
    certificateListData: certificateListReducer,
    blindboxListData: blindboxListReducer,
    MCQListData: MCQListReducer,
})


const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


const store = createStore(
    reducer, 
    initialState, 
    composeEnhancer(applyMiddleware(thunk)));

export default store;
